import configEnableDialog from "assets/configEnableDialog.svg";
import { SBBox, SBTypography } from "modules/Commons";
import SBConfirmDialog from "modules/Commons/SBForms/SBConfirmDialog";
import { useTranslation } from "react-i18next";

export default ({ open, onClose, countOfItems, onConfirm, onCancel }: any) => {
	const { t } = useTranslation();
	return (
		<SBConfirmDialog
			key={open}
			open={open}
			title={t("enable")}
			onConfirm={onConfirm}
			onCancel={onCancel}
			onClose={onClose}
			confirmColor="primary"
		>
			<SBBox display="flex" flexDirection="column" width="25rem">
				<SBBox mx="auto">
					<img height={140} width={190.21} src={configEnableDialog} />
				</SBBox>
				<SBTypography mt="1.5rem" color="blackTitle.main">
					{t("enableItemsFromSystem", { itemsCount: countOfItems })}
				</SBTypography>
			</SBBox>
		</SBConfirmDialog>
	);
};
